import { setActivePinia } from 'pinia';
import { storePinia } from '../storePinia';
import { useFavouriteStore } from '../storePinia/stores/favourite';
import { useResultsStore } from '../storePinia/stores/results';
import { usePersonalStore } from '../storePinia/stores/personal';
import { useBasketStore } from '../storePinia/stores/basket';
import { useFooterMiniBannerStore } from '../storePinia/stores/footerMiniBanner';

setActivePinia(storePinia); // важливо: це активує Pinia в поточному контексті
const resultsStore = useResultsStore();

class Store {
  /**
   * set results
   * @param name
   * @param value
   */
  setResultsStore(name, value) {
    resultsStore.$patch({ [name]: value });
  }

  setResultsStores(values) {
    if (typeof values === 'string') {
      values = JSON.parse(values);
    }
    if (typeof values === 'object') {
      for (const key in values) {
        this.setResultsStore(key, values[key]);
      }
    }
  }

  /**
   * set module stores
   * @param values
   */
  setStores(values) {
    if (typeof values === 'string') {
      values = JSON.parse(values);
    }

    if (typeof values === 'object') {
      for (const key in values) {
        this.setStore(key, values[key]);
      }
    }
  }

  setStore(name, value) {
    switch (name) {
      case 'favourite':
        useFavouriteStore().$patch(value);
        break;
      case 'personal':
        usePersonalStore().$patch(value);
        break;
      case 'basket':
        useBasketStore().$patch(value);
        break;
      case 'footerMiniBanner':
        useFooterMiniBannerStore().$patch(value);
        break;
      default:
        if (process.env.NODE_ENV === 'development') {
          console.warn(`store ${name} not registered in init`, value);
        }
    }
  }
}

export default Store;
